var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.5H9.75C10.0815 4.5 10.3995 4.6317 10.6339 4.86612C10.8683 5.10054 11 5.41848 11 5.75V12.25C11 12.5815 10.8683 12.8995 10.6339 13.1339C10.3995 13.3683 10.0815 13.5 9.75 13.5H2.25C1.91848 13.5 1.60054 13.3683 1.36612 13.1339C1.1317 12.8995 1 12.5815 1 12.25V5.75C1 5.41848 1.1317 5.10054 1.36612 4.86612C1.60054 4.6317 1.91848 4.5 2.25 4.5H3.5M3.5 3L6 0.5L8.5 3M6 10V1",
    stroke: "#505762",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.dae6426ab52bb391a31e84cba4eaa1de.svg";
export { ForwardRef as ReactComponent };